import { render, staticRenderFns } from "./quotaContent.vue?vue&type=template&id=5129399a&scoped=true&"
import script from "./quotaContent.vue?vue&type=script&lang=js&"
export * from "./quotaContent.vue?vue&type=script&lang=js&"
import style0 from "./quotaContent.vue?vue&type=style&index=0&id=5129399a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129399a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5129399a')) {
      api.createRecord('5129399a', component.options)
    } else {
      api.reload('5129399a', component.options)
    }
    module.hot.accept("./quotaContent.vue?vue&type=template&id=5129399a&scoped=true&", function () {
      api.rerender('5129399a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/fullNode/quotaContent.vue"
export default component.exports